import { useEffect, useState } from "react";
import ModalComponent from "../../../components/modals/ModalComponent";
import { Form, Input, DatePicker, Radio } from "antd";
import toast from "react-hot-toast";
import LoadableButton from "../../../components/button/LoadableButton";
import { AddUpdatePayrollEmployee } from "../../../api/request/payroll/payroll";
import moment from "moment";
import TimeZoneDatePicker from "../../../components/common/TimeZoneDatePicker";

const AddEmployeeModal = ({
  open,
  setOpen,
  employee,
  setEmployee,
  getPayrollData,
  timezoneToday,
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values) => {
    const payload = {
      ...(employee ? { id: employee?.id } : {}),
      ...values,
      dob: values?.dob ? moment(values.dob).format("YYYY-MM-DD") : null,
      joining_date: values?.joining_date
        ? moment(values.joining_date).format("YYYY-MM-DD")
        : null,
    };

    try {
      setIsLoading(true);
      const { data } = await AddUpdatePayrollEmployee(payload);
      if (data?.status) {
        form.resetFields();
        toast.success(data?.message);
        setOpen(false);
        getPayrollData();
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      form.resetFields();
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (employee && open) {
      const [first_name, ...rest] = employee?.name?.split(" ") || ["", ""];
      form.setFieldsValue({
        ...employee,
        first_name,
        last_name: rest.join(" "),
        dob: employee?.dob ? moment(employee?.dob) : null,
        joining_date: employee?.joining_date
          ? moment(employee?.joining_date)
          : null,
      });
    } else {
      form.resetFields();
    }
  }, [employee, open]);

  return (
    <ModalComponent
      isOpen={open}
      setIsOpen={(val) => {
        setOpen(val);
        if (!val) setEmployee(null);
      }}
      title={employee ? "Edit Employee" : "Add Employee"}
      width={800}
    >
      <Form layout="vertical" form={form} onFinish={handleSubmit}>
        {/* Section 1 */}
        <p className="font-medium text-gray-700 mb-2 text-lg">
          Personal Information
        </p>
        <div className="grid grid-cols-2 gap-6">
          <Form.Item
            label="First Name"
            name="first_name"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter first name" size="large" />
          </Form.Item>
          <Form.Item
            label="Last Name"
            name="last_name"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter last name" size="large" />
          </Form.Item>
        </div>

        <div className="grid grid-cols-2 gap-6">
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, type: "email" }]}
          >
            <Input placeholder="Enter email" size="large" />
          </Form.Item>
          <Form.Item label="Contact" name="contact_no">
            <Input placeholder="Mobile No." size="large" />
          </Form.Item>
        </div>

        {/* Address + DOB */}
        <div className="grid grid-cols-2 gap-6">
          <Form.Item
            label="Address"
            name="address"
            rules={[{ required: true }]}
          >
            <Input placeholder="Enter address" size="large" />
          </Form.Item>
          <Form.Item
            label="Date of Birth"
            name="dob"
            rules={[{ required: true }]}
          >
            <TimeZoneDatePicker
              size="large"
              className="w-full"
              format="YYYY-MM-DD"
              timezoneToday={timezoneToday}
            />
          </Form.Item>
        </div>

        {/* Section 2 */}
        <p className="font-medium text-gray-700 mb-2 mt-6 text-lg">
          Employment Information
        </p>
        <div className="grid grid-cols-2 gap-6">
          <Form.Item label="Rate" name="rate">
            <Input placeholder="Rate" size="large" />
          </Form.Item>
          <Form.Item
            label="SIN Number"
            name="sin_no"
            rules={[{ required: true }]}
          >
            <Input placeholder="SIN Number" size="large" />
          </Form.Item>
        </div>

        {/* Joining Date + Exemption */}
        <div className="grid grid-cols-2 gap-6">
          <Form.Item
            label="Joining Date"
            name="joining_date"
            rules={[{ required: true }]}
          >
            <TimeZoneDatePicker
              size="large"
              className="w-full"
              format="YYYY-MM-DD"
              timezoneToday={timezoneToday}
            />
          </Form.Item>
          <Form.Item
            label="EI Exemption"
            name="exemption"
            rules={[{ required: true }]}
          >
            <Radio.Group
              optionType="button"
              buttonStyle="solid"
              className="w-full "
            >
              <Radio value="yes">Yes</Radio>
              <Radio value="no">No</Radio>
            </Radio.Group>
          </Form.Item>
        </div>

        {/* Submit Button */}
        <div className="mt-8">
          <LoadableButton
            type="submit"
            lable="Submit"
            loadingLable={`${employee ? "Updating" : "Adding"} Employee...`}
            isLoading={isLoading}
            className="w-full rounded-lg"
          />
        </div>
      </Form>
    </ModalComponent>
  );
};

export default AddEmployeeModal;
